export default {
  SCENE: 'Scene',
  MEDIA: 'Media',
  AUDIO: 'Audio',
};
